export default __webpack_public_path__ + "static/ScottPepper-538e445de1ba4039579fd3d22a47b564.png";